export class Permission {
    public Id: number;
    public OrgId: number;
    public Perm: string;
    public Desc: string;
}
